import React from "react";
import { Card } from "../../features/ui/card";
import { Skeleton } from "../../features/ui/skeleton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../features/ui/table";

interface MarketingLoaderProps {
    variant?: "marketing-kpi" | "customer-acq" | "conversion-fnl" | "campaign-tbl" | "product-tbl";
    className?: string;
    itemCount?: number; // Optional: customizable item count
}


const MarketingLoader: React.FC<MarketingLoaderProps> = ({ variant = "list", className = "", itemCount = 4 }) => {
    switch (variant) {
        case "marketing-kpi":
            return (
                <div className={`w-full ${className}`} aria-busy="true" role="status">
                    <div className="m-2 mb-4">
                        <Skeleton className="h-12 w-100 rounded-md" />
                        <Skeleton className="h-5 w-3/4 mt-2 rounded-md" />
                    </div>
                </div>
            )

        case "customer-acq":
            return (
                <Card className="bg-white/70 dark:bg-black/70 rounded-xl shadow-xl-soft">
                    <div className={className} aria-busy="true" role="status">
                        <div className="flex flex-row m-3 space-x-2">
                            {/* Larger chart area */}
                            <Skeleton className="h-60 w-6 rounded-lg bg-secondary" />
                            <Skeleton className="h-60 w-full rounded-lg bg-secondary" />
                        </div>
                        <Skeleton className="h-6 w-100 rounded-md m-3 bg-secondary" />
                        <div className="flex justify-center space-x-2 m-3  ">
                            <Skeleton className="h-6 w-12 bg-secondary" />
                            <Skeleton className="h-6 w-12 bg-secondary" />
                        </div>
                    </div>
                </Card>
            )

        case "conversion-fnl":
            return (
                <Card className="bg-white/70 dark:bg-black/70 rounded-xl shadow-xl-soft">
                    <div className="space-y-8" style={{ maxHeight: "310px", overflowY: "auto" }}>
                        {Array(itemCount ?? 4).fill(0).map((_, i) => (
                            <div key={i} className={className} aria-busy="true" role="status">
                                <div className="flex justify-between space-x-2 ml-3 mr-3 mt-4 ">
                                    <Skeleton className="h-4 w-12 bg-secondary" />
                                    <Skeleton className="h-4 w-12 bg-secondary" />
                                </div>
                                <Skeleton className="h-2 w-100 rounded-md ml-3 mr-3 mt-2 bg-secondary" />
                            </div>
                        ))}
                    </div>
                </Card>
            )

        case "campaign-tbl":
            return (
                <Card className="bg-white/70 dark:bg-black/70 rounded-xl shadow-xl-soft overflow-hidden" style={{ maxHeight: "615px", overflowY: "auto" }} aria-busy="true" role="status">
                    <div className="m-2">
                        <Table>
                            <TableHeader>
                                <TableRow>
                                    <TableHead>Campaign</TableHead>
                                    <TableHead>Type</TableHead>
                                    <TableHead>Channel</TableHead>
                                    <TableHead>Conversions</TableHead>
                                    <TableHead>Spend</TableHead>
                                    <TableHead>Revenue</TableHead>
                                    <TableHead>ROAS</TableHead>
                                    <TableHead>Lift</TableHead>

                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {[...Array(10)].map((_, rowIndex) => (
                                    <TableRow key={rowIndex}>
                                        <TableCell><Skeleton className="h-4 w-24 bg-secondary" /></TableCell>
                                        <TableCell><Skeleton className="h-5 w-12 rounded-full bg-secondary" /></TableCell>
                                        <TableCell><Skeleton className="h-4 w-20 bg-secondary" /></TableCell>
                                        <TableCell><Skeleton className="h-4 w-16 bg-secondary" /></TableCell>
                                        <TableCell><Skeleton className="h-4 w-16 bg-secondary" /></TableCell>
                                        <TableCell><Skeleton className="h-4 w-16 bg-secondary" /></TableCell>
                                        <TableCell><Skeleton className="h-4 w-10 bg-secondary" /></TableCell>
                                        <TableCell><Skeleton className="h-4 w-10 bg-secondary" /></TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </Card>
            );

            case "product-tbl":
                return(
                    <Card className="bg-white/70 dark:bg-black/70 rounded-xl shadow-xl-soft overflow-hidden" style={{ maxHeight: "615px", overflowY: "auto" }} aria-busy="true" role="status">
                    <div className="m-2">
                        <Table>
                            <TableHeader>
                                <TableRow>
                                    <TableHead>Product</TableHead>
                                    <TableHead>Category</TableHead>
                                    <TableHead>Campaign</TableHead>
                                    <TableHead>Views</TableHead>
                                    <TableHead>Conversion Rate</TableHead>
                                    <TableHead>Revenue</TableHead>
                                    <TableHead>Campaign Lift</TableHead>
                                    
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {[...Array(10)].map((_, rowIndex) => (
                                    <TableRow key={rowIndex}>
                                        <TableCell><Skeleton className="h-4 w-24 bg-secondary" /></TableCell>
                                        <TableCell><Skeleton className="h-5 w-12 rounded-full bg-secondary" /></TableCell>
                                        <TableCell><Skeleton className="h-4 w-20 bg-secondary" /></TableCell>
                                        <TableCell><Skeleton className="h-4 w-16 bg-secondary" /></TableCell>
                                        <TableCell><Skeleton className="h-4 w-16 bg-secondary" /></TableCell>
                                        <TableCell><Skeleton className="h-4 w-16 bg-secondary" /></TableCell>
                                        <TableCell><Skeleton className="h-4 w-10 bg-secondary" /></TableCell>
                                        
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </Card>
                )
    }

};

export default MarketingLoader;